const baseFilters = ['specificPost', 'keyword'];
const baseFiltersWithDate = [...baseFilters, 'date'];
const baseFiltersWithHashtag = [...baseFilters, 'hashtag'];

const filtersWithDateAndHashtag = [...baseFiltersWithDate, 'hashtag'];
const filtersWithSpecificUser = [...filtersWithDateAndHashtag, 'specificUser'];
const filtersPinterestWithSpecificUser = [
  'specificPost',
  'keyword',
  'hashtag',
  'specificUser'
];

// Список доступных фильтров для источников, чтоб применять
// только доступные фильтры на уровне продукта
export const availableFiltersBySource = {
  instagramAccount: filtersWithDateAndHashtag,
  instagramMentions: filtersWithDateAndHashtag,
  instagramHashtag: filtersWithDateAndHashtag,
  legacyInstagramBusinessAccount: filtersWithDateAndHashtag,
  legacyInstagramPersonalAccount: filtersWithDateAndHashtag,
  facebookPage: filtersWithDateAndHashtag,
  tumblrData: filtersWithDateAndHashtag,
  twitterProfile: filtersWithDateAndHashtag,
  twitterHashtag: filtersWithSpecificUser,
  legacyTwitterProfile: filtersWithDateAndHashtag,
  legacyTwitterHashtag: filtersWithSpecificUser,
  linkedinSource: baseFiltersWithHashtag,
  pinterestData: filtersWithDateAndHashtag,
  pinterestProfile: baseFiltersWithHashtag,
  pinterestBoard: filtersPinterestWithSpecificUser,
  vkontaktePage: filtersWithDateAndHashtag,
  vkontakteProfile: filtersWithDateAndHashtag,
  vkontakteGroup: filtersWithSpecificUser,
  vkontakteOwnProfile: filtersWithDateAndHashtag,
  vkontaktePublic: filtersWithDateAndHashtag,
  tiktokSource: filtersWithDateAndHashtag,
  tiktokProfile: filtersWithDateAndHashtag,
  tiktokHashtag: filtersWithSpecificUser,
  rssFile: baseFiltersWithDate,
  vimeoUser: baseFiltersWithDate,
  vimeoChannel: baseFiltersWithDate,
  vimeoGroup: baseFiltersWithDate,
  vimeoShowcase: baseFiltersWithDate,
  vimeoSpecificVideo: baseFiltersWithDate,
  youtubeChannel: baseFiltersWithDate,
  youtubePlaylist: baseFiltersWithDate
};
